export const PAYROLL_ADJUSTMENT = {
    UPDATE_PAYROLL_DAILYLOG: "UPDATE_PAYROLL_DAILYLOG",
    UPDATE_PAYROLL_DAILYLOG_SUCCESS: "UPDATE_PAYROLL_DAILYLOG_SUCCESS",
    UPDATE_PAYROLL_DAILYLOG_FAIL: "UPDATE_PAYROLL_DAILYLOG_FAIL",

    APPROVE_DAILYLOG: "PAYROLL_DAILYLOG_SEARCH",
    APPROVE_DAILYLOG_SUCCESS: "PAYROLL_DAILYLOG_SEARCH_SUCCESS",
    APPROVE_DAILYLOG_FAIL: "PAYROLL_DAILYLOG_SEARCH_FAIL",

    CREATE_DAILYLOG: "PAYROLL_DAILYLOG_SEARCH",
    CREATE_DAILYLOG_SUCCESS: "PAYROLL_DAILYLOG_SEARCH_SUCCESS",
    CREATE_DAILYLOG_FAIL: "PAYROLL_DAILYLOG_SEARCH_FAIL",

    PAYROLL_DAILYLOG_DETAIL: "PAYROLL_DAILYLOG_SEARCH",
    PAYROLL_DAILYLOG_DETAIL_SUCCESS: "PAYROLL_DAILYLOG_SEARCH_SUCCESS",
    PAYROLL_DAILYLOG_DETAIL_FAIL: "PAYROLL_DAILYLOG_SEARCH_FAIL",

    HOURS_REVIEW_SEARCH: "PAYROLL_DAILYLOG_SEARCH",
    HOURS_REVIEW_SEARCH_SUCCESS: "PAYROLL_DAILYLOG_SEARCH_SUCCESS",
    HOURS_REVIEW_SEARCH_FAIL: "PAYROLL_DAILYLOG_SEARCH_FAIL",


    PAYROLL_DAILYLOG_SEARCH: "PAYROLL_DAILYLOG_SEARCH",
    PAYROLL_DAILYLOG_SEARCH_SUCCESS: "PAYROLL_DAILYLOG_SEARCH_SUCCESS",
    PAYROLL_DAILYLOG_SEARCH_FAIL: "PAYROLL_DAILYLOG_SEARCH_FAIL",

    PAYROLL_ADJUSTMENT_DATA_LOAD: "DRIVER_EFFICIENCY_DATA_LOAD",
    PAYROLL_ADJUSTMENT_DATA_LOAD_SUCCESS: "DRIVER_EFFICIENCY_DATA_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_DATA_LOAD_FAIL: "DRIVER_EFFICIENCY_DATA_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD: "PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD",
    PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_SUCCESS: "PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_FAIL: "PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD: "PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD",
    PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_FAIL: "PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD: "PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD",
    PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_FAIL: "PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD: "PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD",
    PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_FAIL: "PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD: "PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD",
    PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_FAIL: "PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD: "PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD",
    PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_SUCCESS: "PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_FAIL: "PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD: "PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD",
    PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_FAIL: "PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_FAIL",

    PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD: "PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD",
    PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_SUCCESS: " PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_SUCCESS",
    PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_FAIL: "PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_FAIL",
}